import {
    startOfDay,
    endOfDay,
    subDays,
    addDays,
    endOfMonth,
    isSameDay,
    isSameMonth,
    addHours
} from 'date-fns';

export class CalendarFakeDb {

    public static data = [
        {
            id: 'events',
            data: [
                {
                    start: subDays(startOfDay(new Date()), 1),
                    end: addDays(new Date(), 1),
                    title: 'Leave request from PRATP',
                    allDay: true,
                    color: {
                        primary: '#F44336',
                        secondary: '#FFCDD2'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd: true
                    },
                    // draggable: true,
                    meta: {
                        location: 'Los Angeles',
                        notes: 'Going to temple with family'
                    }
                },
                {
                    start: startOfDay(new Date()),
                    title: 'Permission request from SIVABALAN',
                    allDay: false,
                    color: {
                        primary: '#FF9800',
                        secondary: '#FFE0B2'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd: true
                    },
                    // draggable: true,
                    meta: {
                        location: 'Los Angeles',
                        notes: 'Going to hospital'
                    }
                },
                {
                    start: subDays(endOfMonth(new Date()), 3),
                    end: addDays(endOfMonth(new Date()), 3),
                    title: 'ERP team meeting',
                    allDay: false,
                    color: {
                        primary: '#1E90FF',
                        secondary: '#D1E8FF'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd: true
                    },
                    // draggable: true,
                    meta: {
                        location: 'Los Angeles',
                        notes: 'Daily meeting'
                    }
                },
                {
                    start: addHours(startOfDay(new Date()), 2),
                    end: new Date(),
                    title: 'TODAY TASK',
                    allDay: false,
                    color: {
                        primary: '#673AB7',
                        secondary: '#D1C4E9'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd: true
                    },
                    // draggable: true,
                    meta: {
                        location: 'Los Angeles',
                        notes: 'Must complete the violation functionalities'
                    }
                }
            ]
        }
    ];
}